import qs from 'qs';

import { axiosInstance } from 'network/apis';

import { URL_AUTH, OAUTH2_CLIENT_ID, OAUTH2_CLIENT_SECRET } from 'utils/constants';

export const callSignIn = async (id, password, rememberMe) => {
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
    };

    const data = {
        client_id: OAUTH2_CLIENT_ID,
        client_secret: OAUTH2_CLIENT_SECRET,
        grant_type: 'password',
        scope: 'Shop_Auth offline_access openid',
        username: id,
        password: password,
        // 'remember': signIn.remember,
        LoginPath: 'shop',
    };

    return await axiosInstance.post('/connect/token', qs.stringify(data), { baseURL: URL_AUTH, headers });
};
